<template>
  <VDialogV3
    id="trade-mark-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localTradeMark"
    :submit-disabled="saveDisabled"
    :submit-method="submit"
  >
    <section>
      <VInput
        ref="nameInput"
        v-model="localTradeMark.name"
        label="Название"
        layout="vertical"
        :validate-method="validateName"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import TradeMark            from '@/domains/TradeMarks/TradeMark';
import TradeMarksService    from '@/domains/TradeMarks/TradeMarksService';

export default defineComponent({
  name: 'TradeMarkCard',

  props: {
    tradeMark: {
      type:    TradeMark as PropType<TradeMark | null>,
      default: null,
    },
    id: {
      type:    Number,
      default: null,
    },
  },

  data() {
    return {
      localTradeMark: null as TradeMark | null,
    };
  },

  computed: {
    /**
     * Причина запрета сохранения (строка → :submit-disabled показывает тултип).
     * Удалённую марку редактировать нельзя. Валидность поля ведёт сам VDialogV3.
     */
    saveDisabled(): string | null {
      if (this.localTradeMark?.isDeleted) {
        return 'Торговая марка удалена';
      }
      else {
        return null;
      }
    },
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localTradeMark = await TradeMarksService.get(this.id);
      }
      else if (this.tradeMark instanceof TradeMark) {
        this.localTradeMark = this.$core.utils.cloneDeep(this.tradeMark);
      }
    },

    async submit(): Promise<boolean> {
      return await TradeMarksService.update(this.localTradeMark);
    },

    validateName(value: string): string | null {
      if (typeof value !== 'string' || value.trim().length === 0) { return 'Поле обязательно'; }
      if (value.length > 200) { return 'Максимальная длина поля 200 символов'; }
      return null;
    },
  },
});
</script>